import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import { useIntl } from '@mfw/components';

import messages from './messages';

export const TermsOfUseLoadState = ({
  isPending,
  isError,
  isUnavailable,
}: {
  isPending: boolean;
  isError: boolean;
  isUnavailable: boolean;
}) => {
  const { formatMessage } = useIntl();
  if (isPending) {
    return (
      <Typography role="status" variant="body2">
        {formatMessage(messages.loading)}
      </Typography>
    );
  }
  if (isError) {
    return <Alert severity="error">{formatMessage(messages.loadError)}</Alert>;
  }
  if (isUnavailable) {
    return (
      <Alert severity="warning">
        {formatMessage(messages.purchaseUnavailable)}
      </Alert>
    );
  }
  return null;
};
